import { TopicComparisonMeasureType, MessageConst } from 'enums'
import { TopicComparisonMeasureTypeStrings } from 'enums/TopicComparisonMeasureType'
import { RowData } from './types'

const topicNameComparator = (obj1: RowData, obj2: RowData) => {
  const topicName1 = obj1.topicName!.toLowerCase()
  const topicName2 = obj2.topicName!.toLowerCase()

  if (topicName1 < topicName2) {
    return -1
  }
  if (topicName1 === topicName2) {
    return 0
  }
  return 1
}

const createComparator = (key: keyof RowData) => (obj1: RowData, obj2: RowData) => {
  const { value: value1, formattedValue: formattedValue1 } = obj1[key] || {}
  const { value: value2, formattedValue: formattedValue2 } = obj2[key] || {}
  if (formattedValue1 === MessageConst.EM_DASH && formattedValue2 !== MessageConst.EM_DASH) {
    return 1
  }
  if (formattedValue1 !== MessageConst.EM_DASH && formattedValue2 === MessageConst.EM_DASH) {
    return -1
  }
  if (value1 > value2) {
    return -1
  }
  if (value1 < value2) {
    return 1
  }
  return topicNameComparator(obj1, obj2)
}

const getComparator = (rankBy: TopicComparisonMeasureTypeStrings) => {
  switch (rankBy) {
    case TopicComparisonMeasureType.PASSION:
    case TopicComparisonMeasureType.IMPRESSIONS:
    case TopicComparisonMeasureType.NET_SENTIMENT:
    case TopicComparisonMeasureType.UNIQUE_AUTHORS:
    case TopicComparisonMeasureType.POSTS:
    case TopicComparisonMeasureType.MENTIONS:
      return createComparator(rankBy)
    default:
      return createComparator(TopicComparisonMeasureType.MENTIONS)
  }
}

export default getComparator
